import { DOCUMENTS_GET, DOCUMENT_FILES_GET, DOCUMENT_FILE_GET } from '../actions/types';

const initialState = {
  items: {},
  files: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DOCUMENTS_GET._SUCCESS: {
      const { userId, documents } = action.payload;
      state.items[userId] = documents;
      return state;
    }
    case DOCUMENT_FILES_GET._SUCCESS: {
      const { documentId, documentFiles } = action.payload;
      state.files[documentId] = documentFiles;
      return state;
    }
    case DOCUMENT_FILE_GET._SUCCESS: {
      const { documentId, fileId, file } = action.payload;
      if (state.files[documentId]) {
        state.files[documentId][fileId] = file;
      } else {
        state.files[documentId] = {};
        state.files[documentId][fileId] = file;
      }
      return state;
    }
    default:
      return state;
  }
};

export { reducer as documents };
